import React, { Fragment, useEffect, useState } from "react";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../../utils/AppInsights";
import Loader from "../Common/Loader";
import Emptystate from "./StyleEmptyState";
import { useSelector } from 'react-redux';
import { DndContext, closestCenter, KeyboardSensor, PointerSensor, useSensor, useSensors, } from '@dnd-kit/core';
import { arrayMove, SortableContext, sortableKeyboardCoordinates, rectSortingStrategy } from '@dnd-kit/sortable';
import { StyleSortableContent } from './StyleSortableContent';

import StencilsLoader from "../Common/StyleLoader";
import { MobileCallbackTypes, utils } from "utils/Utils";


const StyleContent = (props) => {
    const { ReactBusinessId ,IsViewAllowed,IsModifyAllowed} = useSelector((state) => state.Business);

    const [maxItems, setMaxItems] = useState(window.matchMedia("(max-width: 991px)").matches ? 2 : 3);
    const reportWindowOrientationChange = () => {
        if (window.matchMedia("(max-width: 991px)").matches) {
            setMaxItems(2);
        }
        else {
            setMaxItems(3);
        }
    }
    window.onorientationchange = reportWindowOrientationChange;
    const cardImgPath = window.location.href.indexOf("vagaro.com") > 0 ? ("https://d396040dc4cf62cf5770-d11e112dbdab6afc64c448f17b56c3c3.ssl.cf2.rackcdn.com/WB/"):("https://f745786de3dd98dac855-36e09dc6f87385bab9d0e7ff5c0d38c7.ssl.cf2.rackcdn.com/WB/");
    const cardImgPlaceholder =
        "https://1a96a36bae7c8550901a-274b8a70320bb26e7a1e0ea7836ee429.ssl.cf2.rackcdn.com/PublicImages/Images/template-thum-empty.gif";




    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );


    const [items, setItems] = useState(props.styleList);
    useEffect(() => {
        setItems(props.styleList)
    }, [props.styleList])


    return (
        <Fragment>
            {props.isLoading &&  <Loader />}
            {props.isStencilsLoader &&  <StencilsLoader styleList={props.styleList} />}
            
            <div className="">                
                {props.IsFirtTimeBinding == false && props.totalCount > 0 && props.styleList.length == 0 && props.isSessionCheck && <Emptystate
                    wrapperClass={"empty-style"}
                    stateIcon={"fa-th-large"}
                    stateTitle={"No Style Found"}
                    stateDescription={"There are no styles in the style library. Start by creating a new style."}
                    stateButtonActions={"d"}
                    stateButtonText={"Add Style"}
                    OpenPopup={props.AddStylePopup}
                    {...props}
                />}

                {props.IsFirtTimeBinding == false && props.totalCount == 0 && props.styleList.length == 0 && props.isSessionCheck && <Emptystate
                    wrapperClass={"empty-style"}
                    stateIcon={"fa-th-large"}
                    stateTitle={"Start from Scratch"}
                    stateDescription={"There are no styles in the style library. Start by creating a new style."}
                    stateButtonActions={"d"}
                    stateButtonText={"Start from Scratch"}
                    OpenPopup={props.startFromStratchLayoutStyle}
                    {...props}
                />}
                {ReactBusinessId == 0 &&
                    <Fragment>

                        <DndContext
                            sensors={sensors}
                            collisionDetection={closestCenter}
                            onDragEnd={handleDragEnd}
                        >
                            <div className="styles-cards-wrapper styles-cards-wrapper-business onlystyles" id="stylesWrapper">
                                <SortableContext
                                    items={items}
                                    strategy={rectSortingStrategy}

                                >
                                    {items.map(d => <StyleSortableContent
                                        key={d.id}
                                        id={d.id}
                                        handle={true}
                                        businessStyleId={d.businessStyleId}
                                        categoryid={d.categoryid}
                                        isActive={d.isActive}
                                        isExistTemplate={d.isExistTemplate}
                                        isNewest={d.isNewest}
                                        isPopular={d.isPopular}
                                        isSoftDelete={d.isSoftDelete}
                                        overallCount={d.overallCount}
                                        rank={d.rank}
                                        subCategoryId={d.subCategoryId}
                                        styleImage={d.styleImage}
                                        styleTitle={d.styleTitle}
                                        EditStyleSetting={props.EditStyleSetting}
                                        CreateLayout={props.CreateLayout}
                                        EditStyle={props.ViewStyle}
                                        DuplicateStyle={props.DuplicateStyle}
                                        ActivateStylePopup={props.ActivateStylePopup}
                                        DeactivateStylePopup={props.DeactivateStylePopup}
                                        DeleteStylePopup={props.DeleteStylePopup}
                                        BusinessChangeStyle={props.BusinessChangeStyle}
                                        UseStyle={props.UseStyle}
                                        ViewStyle={props.ViewStyle}
                                        isFromParentAll={props.isFromParentAll}
                                        isFromAll={props.isFromAll}
                                        isPopuplar={props.isPopuplar}
                                        isActiveStyle={props.isActiveStyle}
                                        isInActiveStyle={props.isInActiveStyle}
                                        showLayout={props.showLayout}
                                        layoutlist={props.layoutlist}
                                        allLayoutName={props.allLayoutName}
                                        Layoutalert={props.Layoutalert}
                                    />)}
                                </SortableContext>
                            </div>
                        </DndContext>
                    </Fragment>

                }
                {ReactBusinessId > 0 &&
                    <div className="styles-cards-wrapper styles-cards-wrapper-business onlystyles" id="stylesWrapper">
                        {props.styleList.length > 0 && props.styleList.map((d,index) => {
                            return (
                                <Fragment key={d.id}>
                                    <div className="styles-card-col">
                                        <div className={d.businessStyleId != "" ? "styles-card selected" : "styles-card"} >
                                            <div className="styles-card-thum-frame">
                                                <span className="dots" />
                                                <img
                                                    className="styles-card-thum"
                                                    src={cardImgPlaceholder}
                                                    alt={d.styleTitle}
                                                    style={{ backgroundImage: `url('${cardImgPath + d.styleImage}')`, }}
                                                    onClick={(e) => { utils.IsFromProApp() == true  && d.isExistStyle == true && d.businessStyleId == "" ?  props.BusinessChangeStyle(d.id) : (d.isExistStyle == true && d.businessStyleId !== "" ? props.UseStyle(d.id, d.businessTemplateIdentity) : props.showLayout(d.id)) }}
                                                />
                                                {utils.IsFromProApp() == true && d.isExistStyle == true && d.businessStyleId !== "" &&
                                                        <div className="btn-row">
                                                            <a id={"edit-style-btn"}
                                                               onClick={(e) => { props.UseStyle(d.id, d.businessTemplateIdentity) }}
                                                               className="w-button w-button-primary"
                                                               style={{display:"none"}} >
                                                                Edit Style
                                                            </a>
                                                        </div>
                                                            
                                                }
                                                {utils.IsFromProApp() == false &&
                                                <div className="styles-card-overlay">
                                                    <Fragment>
                                                        {d.isExistStyle == true && d.businessStyleId == "" && 
                                                            <div className="btn-row">
                                                                <a
                                                                    onClick={(e) => { props.BusinessChangeStyle(d.id); }}
                                                                    className={"w-button w-button-primary style-" + d.id}
                                                                >
                                                                    Change Style
                                                                </a>
                                                            </div>
                                                        }
                                                        {d.isExistStyle == true && d.businessStyleId !== "" &&
                                                            <div className="btn-row">
                                                                <a
                                                                    id={"edit-style-btn"}
                                                                    onClick={(e) => { props.UseStyle(d.id, d.businessTemplateIdentity) }}
                                                                    className={"w-button w-button-primary"}
                                                                >
                                                                    Edit Style
                                                                </a>
                                                            </div>
                                                        }
                                                        {d.isExistStyle == false && d.businessStyleId == "" &&
                                                            <div className="btn-row">
                                                                <a
                                                                    onClick={(e) => { props.showLayout(d.id) }}
                                                                    className={"w-button w-button-primary style-" + d.id}
                                                                >
                                                                    Start With This Style
                                                                </a>
                                                            </div>
                                                        }
                                                    </Fragment>
                                                </div>
                                                }
                                            </div>
                                            <div className="styles-card-item">
                                                <h3 className="">
                                                    {d.styleTitle}

                                                    {d.isNewest &&
                                                        <span className="badge badge-primary">
                                                            NEW
                                                        </span>}
                                                    {" "}
                                                    {d.isPopular &&
                                                        <span className="badge badge-secondary">
                                                            POPULAR
                                                        </span>
                                                    }
                                                </h3>
                                            </div>

                                        </div>
                                    </div>
                                </Fragment>
                            )
                        })}
                    </div>
                }
            </div>
        </Fragment>
    );
    function handleDragEnd(event) {
        const { active, over } = event;


        if (active.id !== over.id) {
            setItems((items) => {
                const oldIndex = items.findIndex(x => x.id === active.id);
                const newIndex = items.findIndex(x => x.id === over.id);

                props.ReorderList(oldIndex, newIndex);
                return arrayMove(items, oldIndex, newIndex);


            });
        }

    }
}


export default withAITracking(reactPlugin, StyleContent);